import VueRouter from "vue-router";

const router = new VueRouter({
  routes: [{
      path: "/",
      redirect: "/index"
    },
    {
      path: "/index",
      component: () =>
        import ("@views/Index.vue")
    },
    {
      path: "/keywordsearch/:keyword",
      component: () =>
        import ("@views/searchResult/SingleSearchResult.vue")
    },
    {
      path: "/oesearch/single",
      component: () =>
        import ("@views/searchResult/SingleSearchResult.vue")
    },
    {
      path: "/oesearch/multi",
      component: () =>
        import ("@views/searchResult/MultiSearchResult.vue")
    },
    {
      path: "/genartsearch/:genCmdtyId/:genCmdtyName",
      component: () =>
        import ("@views/searchResult/GenArtSearchResult.vue")
    },
    {
      path: "/sku/:id",
      component: () =>
        import ("@views/searchResult/SkuDetail.vue")
    },
    {
      path: "/vehiclesearch/:typeId",
      component: () =>
        import ("@views/searchResult/VehicleSearchResult.vue")
    },
    {
      path: "/buyer",
      component: () =>
        import ("@views/buyer/Index/Layout.vue"),
      children: [{
          path: "/",
          component: () =>
            import ("@views/buyer/Index/Index.vue")
        },
        {
          path: "message",
          component: () =>
            import ("@views/buyer/Index/Message.vue")
        },
        {
          path: "order",
          component: () =>
            import ("@views/buyer/manage/Order.vue"),
          children: [{
            path: ":id",
            component: () =>
              import ("@views/buyer/manage/OrderDetail.vue")
          }]
        },
        {
          path: "affirm",
          component: () =>
            import ("@views/buyer/manage/Affirm.vue")
        },
        {
          path: "apply",
          component: () =>
            import ("@views/buyer/manage/Apply.vue"),
          children: [{
              path: "create",
              component: () =>
                import ("@views/buyer/manage/ApplyCreate.vue")
            },
            {
              path: ":id",
              component: () =>
                import ("@views/buyer/manage/ApplyDetail.vue")
            }
          ]
        },
        {
          path: "account",
          component: () =>
            import ("@views/buyer/manage/Account.vue")
        },
        {
          path: "shoppingList",
          component: () =>
            import ("@views/buyer/Attention/ShoppingList.vue"),
          children: [{
            path: ":id",
            component: () =>
              import ("@views/buyer/Attention/ShoppingDetail.vue")
          }]
        },
        {
          path: "viewHistory",
          component: () =>
            import ("@views/buyer/Attention/ViewHistory.vue")
        },
        {
          path: "accountSet",
          component: () =>
            import ("@views/buyer/userInfo/AccountSet.vue")
        },
        {
          path: "address",
          component: () =>
            import ("@views/buyer/userInfo/Address.vue")
        },
        {
          path: "invoiceTitle",
          component: () =>
            import ("@views/buyer/userInfo/InvoiceTitle.vue")
        }
      ]
    },
    {
      path: "/shoppingCar",
      component: () =>
        import ("@views/buyer/ShoppingCar.vue")
    },
    {
      path: "/shoppingCheck",
      component: () =>
        import ("@views/buyer/ShoppingCheck.vue")
    },
    {
      path: "/shoppingSubmited/:id/:number/:amount/:paymentMode",
      component: () =>
        import ("@views/buyer/ShoppingSubmited.vue")
    }
  ]
});

router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});

export default router;